module.exports = __webpack_public_path__ + "img/SoNs-2019-23.dd9520ff.jpeg";